<!--
  AI-JAVADOC: WfProcessStepActivityUfFormComponent Template
  Module: WF (Workflow)
  Description: Renders a UF form renderer as a workflow activity. Shows loading state,
               error state, and the embedded uf-form-renderer component.
-->
@if (initialized) {

    <!-- Activity description -->
    @if (activityType && activityType.description) {
        <div class="card quickview --workflowS">
            <div [innerHTML]="activityType.description | mvsSavePipe:'html'"></div>
        </div>
    }

    <!-- Error state: form creation failed -->
    @if (formCreationError) {
        <div class="flex align-items-center gap-2 p-3 border-round surface-100 text-red-600">
            <i class="fa-regular fa-circle-exclamation"></i>
            <span>Formular konnte nicht erstellt werden. Bitte versuchen Sie es erneut.</span>
        </div>
    }

    <!-- Loading state -->
    @if (busy) {
        <div class="flex align-items-center justify-content-center p-5">
            <i class="fa-regular fa-spinner fa-spin mr-2"></i>
            <span>Formular wird geladen...</span>
        </div>
    }

    <!-- UF Form Renderer -->
    @if (!busy && !formCreationError && ufFormRuntime) {
        <uf-form-renderer
            [formId]="ufFormId"
            [formRuntime]="ufFormRuntime"
            (onSave)="onFormSaved($event)"
            (onCancel)="onFormCancelled()">
        </uf-form-renderer>
    }

}
